import { useIsMobileScreenSelector } from '~/store/frontendState/deviceInfo/deviceInfo.selector';
import { useFrontendStateLeftSidebarOpenedAppSelector } from '~/store/frontendState/leftSidebar/leftSidebar.selectors';

export const useIsMobileToolPanelOpen = () => {
  const isMobileScreen = useIsMobileScreenSelector();
  const openedApp = useFrontendStateLeftSidebarOpenedAppSelector();

  return isMobileScreen && openedApp !== null;
};
